//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminAccountingUsageController_list,
  Response$AdminAccountingUsageController_list$Status$200,
  ResponseContentType$AdminAccountingUsageController_list,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminAccountingUsageController_list = (options: {
  params: Params$AdminAccountingUsageController_list['parameter'];
  config?: QueryOptions<
    Response$AdminAccountingUsageController_list$Status$200[ResponseContentType$AdminAccountingUsageController_list]
  >;
}) =>
  useApiClient<
    Params$AdminAccountingUsageController_list,
    Response$AdminAccountingUsageController_list$Status$200[ResponseContentType$AdminAccountingUsageController_list]
  >({
    method: 'AdminAccountingUsageController_list',
    params: { parameter: options.params },
    config: options.config,
  });
